import moment  from "moment";
import MessageType from "./MessageType";
import emoji from "../../emoji/emoji";
import config from '../../utils/config.js'
import defaultImage from '../../utils/defaultImage.js'
import chatDataCenter from "../../jsSdk/chatDataCenter";
import "../../../static/css/main.css";
import common from "../../utils/common";

const Message = function (obj) {
  this._init_(obj);
};

Message.prototype = {
  constructor: Message,
  _init_: function (obj) {
    if (obj) {
      this.id = obj.id;
      this.messageId = obj.messageId;
      this.sessionId = obj.sessionId;
      this.customerId = obj.customerId;
      this.customerChannelId = obj.customerChannelId;
      this.companyId = obj.companyId;
      this.messageDirection = obj.messageDirection; //C:顾客发给客服；U客服发给顾客，S系统
      this.messageType = obj.messageType; //T:文本 I:图片 V:视频 F:文件 S1:系统消息(发送给顾客) S2:系统消息(发送给客服) R:机器人回复消息
      this.messageStatus = obj.messageStatus;//-1:发送失败0:发送中10:未读 20:已读 30:离线:40撤回
      this.messageContent = obj.messageContent;
      this.messageContentSimple = obj.messageContentSimple;
      this.senderId = obj.senderId;
      this.bindId = obj.bindId;
      this.receiveId = obj.receiveId;
      this.senderCode = obj.senderCode;
      this.senderNickname = obj.senderNickname;
      this.senderAvatar = obj.senderAvatar;
      this.sendTime = obj.sendTime;//发送时间
      this.recallTime = obj.recallTime;//撤回时间
      this.readTime = obj.readTime;//已读时间
      this.mediaUrl = obj.mediaUrl;//文件路径
      this.solveStatus = '1';//未提交,2已解决3,未解决
      this.robotName = obj.robotName;//机器人客服名称
      this.robotAvatar = obj.robotAvatar;//机器人客服头像
      // 前端辅助字段
      this.retryCount = obj.retryCount;
      this.successCallback = obj.successCallback;// 消息发送成功回调函数
      this.failCallback = obj.failCallback;// 消息发送失败回调函数
      this.readCallback = obj.readCallback;// 消息被接收方已读回调函数
      this.sendFileStatus=obj.sendFileStatus==undefined?1:obj.sendFileStatus;//0:上传中,1:上传成功，2:上传失败
      this.isOpen = false;
      this.isHasOpen = false;
      this.height = "unset";
      if(obj.questionSource && obj.questionSource != null && obj.questionSource != ''){
        this.questionSource = obj.questionSource;
      }else{
        this.questionSource = 'click';
      }
    }
  },

  showType:function () {
    var _this=this;
    if(_this.messageType== MessageType.R&&_this.isJSON(_this.messageContent)){
      var data = JSON.parse(_this.messageContent);
      if( data.choices.length > 0||data.suggestions.length > 0){// 有选项消息
        return true;
      }
    }
    if(_this.messageType== MessageType.Z&&JSON.parse(_this.messageContent).length>0){
      return true;
    }
    if(_this.messageType== MessageType.I||_this.messageType== MessageType.V||_this.messageType== MessageType.F){
      return true;
    }
    return false;
  },
  getHtml:function () {
    var _this=this;
    switch (this.messageType){
      case MessageType.T:
      case MessageType.R:
        return _this.filterIcon(this.messageType,_this.messageContent);
    }
  },
  filterIcon: function(messageType,messageContent ) {
    var _this=this;
    var content=messageContent;
    if(messageType==MessageType.R&&_this.isJSON(messageContent)){
      content= JSON.parse(messageContent).answer;
    }
    var regexList=[];
    regexList.push({regex:/<a(.*?)target='[^']*'(.*?)>/ig,value:"<a$1target='_blank '$2>"})
    regexList.push({regex:/<a(((?!target).)*?)>/ig,value:"<a target='_blank '$1>"})

    //获取机器人消息体整体宽度
    let contentDivWidth = $('.contentDiv').width() * 0.75;
    let contentDivWidth2 = ($('.contentDiv2').width() - 58) * 0.75;

    if(chatDataCenter.chatTerminal=='WEB'||common.isIOS()||common.isWx()){
      if(chatDataCenter.chatTerminal=='WEB'){
        regexList.push({regex:/<img(.*?)onclick='[^']*'(.*?)>/ig,value:"<img $1 onclick='openRobotLinkEvent(this,\""+"img"+"\") '$2>"})
        regexList.push({regex:/<img(((?!onclick).)*?)>/ig,value:"<img onclick='openRobotLinkEvent(this,\""+"img"+"\") '$1>"})
      }else {
        contentDivWidth = $('.contentDiv').width() * 0.85 - 84;
      }
      // regexList.push({regex:/<video(((?!poster).)*?)>/ig,value:"<video poster='"+config.fileUrl+defaultImage.videoPoster+"'$1>"})
      // regexList.push({regex:/<video(.*?)onclick='[^']*'(.*?)>/ig,value:"<video $1 onclick='openRobotLinkEvent(this,\""+"video"+"\") '$2>"})
      // regexList.push({regex:/<video(((?!onclick).)*?)>/ig,value:"<video onclick='openRobotLinkEvent(this,\""+"video"+"\") '$1>"})
      //
      // regexList.push({regex:/<video(.*?)controls='[^']*'(.*?)>/ig,value:"<video$1  $2>"})
      // regexList.push({regex:/<video(.*?)controls(.*?)>/ig,value:"<video$1 $2>"})
      // regexList.push({regex:/<video(.*?)preload='[^']*'(.*?)>/ig,value:"<video$1  $2>"})
      // regexList.push({regex:/<video(.*?)preload(.*?)>/ig,value:"<video$1 $2>"})
      regexList.push({regex:/<video(.*?)controls='[^']*'(.*?)>/ig,value:"<video$1 controls $2>"})
      regexList.push({regex:/<video(((?!controls).)*?)>/ig,value:"<video controls $1>"})
      regexList.push({regex:/<video(.*?)preload="[^"]*"(.*?)>/ig,value:"<video$1 preload='preload' $2>"})
      regexList.push({regex:/<video(((?!preload).)*?)>/ig,value:"<video preload='preload' $1>"})
      regexList.push({regex:/<video(.*?)autoplay='[^']*'(.*?)>/ig,value:"<video$1 $2>"})
      regexList.push({regex:/<video(.*?)autoplay(.*?)>/ig,value:"<video$1 $2>"})

    }else {
      // regexList.push({regex:/<video(.*?)controls='[^']*'(.*?)>/ig,value:"<video$1 controls $2>"})
      contentDivWidth = $('.contentDiv').width() * 0.85 - 84;
      regexList.push({regex:/<video(.*?)controls='[^']*'(.*?)>/ig,value:"<video$1 controls $2>"})
      regexList.push({regex:/<video(((?!controls).)*?)>/ig,value:"<video controls $1>"})
      regexList.push({regex:/<video(.*?)preload="[^"]*'(.*?)>/ig,value:"<video$1 preload='preload' $2>"})
      regexList.push({regex:/<video(((?!preload).)*?)>/ig,value:"<video preload='preload' $1>"})
      regexList.push({regex:/<video(.*?)autoplay='[^']*'(.*?)>/ig,value:"<video$1 $2>"})
      regexList.push({regex:/<video(.*?)autoplay(.*?)>/ig,value:"<video$1 $2>"})
    }
    /**
     * 控制宽高
     */
    const videoContentWidth = content.match(/<video(.*?)width="[^"]*"(.*?)>/ig);
    const videoContentHeight = content.match(/<video(.*?)height="[^"]*"(.*?)>/ig);
    let videoWidth = null;
    let videoHeight = null;
    console.log(content)
    //获取video的宽高
    const videoEleWidth = videoContentWidth ? videoContentWidth[0].match(/width="[^"]*"/ig) : null;
    const videoEleHeight = videoContentHeight ? videoContentHeight[0].match(/height="[^"]*"/ig) : null;
    if(videoEleWidth && videoEleWidth[0]){
      videoWidth = videoEleWidth[0].match(/"[^"]*"/ig)[0].split("\"")[1];
    }
    if(videoEleHeight && videoEleHeight[0]){
      videoHeight = videoEleHeight[0].match(/"[^"]*"/ig)[0].split("\"")[1];
    }
    //判断video的宽和气泡的最大宽 若video大于气泡 则取气泡的宽 高等比例展示  若video小于气泡 则取video本身宽高
    let chatDivWidth = contentDivWidth === 0 ?  contentDivWidth2 : contentDivWidth;
    console.log(chatDivWidth)
    if(videoWidth && videoWidth > chatDivWidth){
      console.log('气泡宽====='+contentDivWidth+'\n'+'video宽======='+videoWidth+'\n'+'video高======='+videoHeight+'\n'+'聊天窗口======='+contentDivWidth2)
      const actualHeight = videoHeight * (chatDivWidth / videoWidth);
      regexList.push({regex:/<video(.*?)width="[^"]*"(.*?)>/ig,value:"<video$1 width='"+chatDivWidth+"' $2>"})
      regexList.push({regex:/<video(.*?)height="[^"]*"(.*?)>/ig,value:"<video$1 height='"+actualHeight+"' $2>"})
    }
    for (var i=0;i<regexList.length;i++){
      content=content.replace(regexList[i].regex,regexList[i].value);
    }
    return emoji.emoji_img(content);
  },
  getSystemHtml:function (sessionIdNow,flag) {
    var keyWordList=[];
    var messageContent=this.messageContent
    if (messageContent.indexOf('#留言#')>-1){
      keyWordList.push('#留言#')
    }
    if (messageContent.indexOf('#重新接入#')>-1){
      keyWordList.push('#重新接入#')
    }
    if (messageContent.indexOf('#人数#')>-1){
      keyWordList.push('#人数#')
    }
    if (messageContent.indexOf('#客服名称#')>-1){
      keyWordList.push('#客服名称#')
    }
    for (var i=0;i<keyWordList.length;i++){
      if(keyWordList[i]=='#重新接入#'){
        if(sessionIdNow==null){
          var keyHtml='<a onclick="initClickEvent(\''+keyWordList[i]+'\')"  style="color: #ffffff;background:#FFB63D;padding:2px 5px;cursor: pointer;border-radius: 25px;white-space: nowrap">'+keyWordList[i]+'</a>';
          messageContent=messageContent.replace(keyWordList[i],keyHtml);
        }
      }
      if(keyWordList[i]=='#留言#'){
        var keyHtml='<a onclick="initClickEvent(\''+keyWordList[i]+'\')" style="color: #ffffff;background:#FFB63D;padding:2px 5px;cursor: pointer;border-radius: 25px;white-space: nowrap">'+keyWordList[i]+'</a>';
        messageContent=messageContent.replace(keyWordList[i],keyHtml);
      }
      if(keyWordList[i]!='#重新接入#'&&keyWordList[i]!='#留言#'){
        if(sessionIdNow!=null&&flag){
          var keyHtml='<a onclick="initClickEvent(\''+keyWordList[i]+'\')"  style="color: #ffffff;background:#FFB63D;padding:2px 5px;cursor: pointer;border-radius: 25px;white-space: nowrap">'+keyWordList[i]+'</a>';
          messageContent=messageContent.replace(keyWordList[i],keyHtml);
        }
      }

    }
    return messageContent;
  },
  getSendTime:function () {
    // return moment(this.sendTime*1).format('MM-DD HH:mm:ss');
    return moment(this.sendTime*1).format(' HH:mm:ss');
  },
  isJSON: function(str ) {
    if (typeof str == 'string') {
      try {
        var obj=JSON.parse(str);
        if(typeof obj == 'object' && obj ){
          return true;
        }else{
          return false;
        }
      } catch(e) {
        return false;
      }
    }
    return false;
  },
  toString: function () {
    return JSON.stringify(this);
  },
};
export default Message;
